var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.58,
    height: 19.549,
    viewBox: "0 0 19.58 19.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 149",
    d: "M.415 6.746A.415.415 0 0 1 0 6.331V.415A.415.415 0 0 1 .415 0h5.916a.415.415 0 0 1 0 .83H.83v5.5a.415.415 0 0 1-.415.415",
    transform: "translate(.29 .29)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150",
    d: "M7.763 8.184a.417.417 0 0 1-.294-.121L.122.708A.415.415 0 0 1 .709.121l7.348 7.354a.415.415 0 0 1-.294.709",
    transform: "translate(.29 .29)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 151",
    d: "M21.089 6.746a.415.415 0 0 1-.415-.415V.83h-5.5a.415.415 0 0 1 0-.83h5.916a.415.415 0 0 1 .41.415v5.916a.415.415 0 0 1-.415.415",
    transform: "translate(-2.214 .29)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 152",
    d: "M13.451 8.184a.415.415 0 0 1-.294-.709L20.5.121a.415.415 0 0 1 .588.587l-7.343 7.355a.417.417 0 0 1-.294.121",
    transform: "translate(-1.922 .29)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 153",
    d: "M6.331 21.514H.415A.415.415 0 0 1 0 21.1v-5.917a.415.415 0 0 1 .83 0v5.5h5.5a.415.415 0 0 1 0 .83",
    transform: "translate(.29 -2.216)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 154",
    d: "M.415 21.22a.415.415 0 0 1-.294-.709l7.348-7.354a.415.415 0 1 1 .587.587L.709 21.1a.417.417 0 0 1-.294.121",
    transform: "translate(.29 -1.922)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 155",
    d: "M21.089 21.514h-5.916a.415.415 0 0 1 0-.83h5.5v-5.5a.415.415 0 0 1 .83 0V21.1a.415.415 0 0 1-.415.415",
    transform: "translate(-2.214 -2.216)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "M20.8 21.22a.417.417 0 0 1-.3-.12l-7.346-7.355a.415.415 0 0 1 .588-.587l7.346 7.354a.415.415 0 0 1-.294.709",
    transform: "translate(-1.922 -1.922)",
    style: {
      fill: "#002647",
      stroke: "#002647",
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.e23b3e18d6c0e641a45c29300431c49a.svg";
export { ForwardRef as ReactComponent };